var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import { forwardRef, NumberInput as ChakraNumberInput, NumberInputField, NumberInputStepper, NumberIncrementStepper, NumberDecrementStepper, useTheme, useColorModeValue, } from "@chakra-ui/react";
import { pick, transparentize } from "../../core";
import { Size, Variant, ColorScheme } from "../../core/constants";
import FormControl from "../FormControl";
export const NumberInputSize = pick(Size, ["sm", "md", "lg"]);
export const NumberInputVariant = pick(Variant, [
    "outline",
    "filled",
    "flushed",
    "unstyled",
]);
/**
 * The number input
 */
const NumberInput = forwardRef((_a, ref) => {
    var { className, keepWithinRange = true, showStepper = true, name, error, label, helper, size, variantColor, colorScheme } = _a, rest = __rest(_a, ["className", "keepWithinRange", "showStepper", "name", "error", "label", "helper", "size", "variantColor", "colorScheme"]);
    const scheme = colorScheme !== null && colorScheme !== void 0 ? colorScheme : variantColor;
    const theme = useTheme();
    const focusBorderColor = useColorModeValue(`${scheme}.500`, transparentize(`${scheme}.500`, 0.5)(theme));
    const errorBorderColor = useColorModeValue(`${ColorScheme.error}.500`, transparentize(`${ColorScheme.error}.500`, 1)(theme));
    return (React.createElement(FormControl, { name: name, label: label, error: error, helper: helper, size: size },
        React.createElement(ChakraNumberInput, Object.assign({}, rest, { name: name, size: size, focusBorderColor: focusBorderColor, errorBorderColor: errorBorderColor, className: className, keepWithinRange: keepWithinRange }),
            React.createElement(NumberInputField, { ref: ref }),
            showStepper && (React.createElement(NumberInputStepper, null,
                React.createElement(NumberIncrementStepper, null),
                React.createElement(NumberDecrementStepper, null))))));
});
NumberInput.displayName = "NumberInput";
export default NumberInput;
//# sourceMappingURL=NumberInput.js.map